import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import {
  CContainer,
  CHeader,
  CHeaderNav,
  CHeaderToggler,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilMenu } from '@coreui/icons'
import { ThemeToggle } from '@scryerlabs/ui'
import { AppBreadcrumb } from './index'
import { AppHeaderDropdown, AppHeaderNotifications } from '../header/index'
import DevRoleSwitcher from '../dev/DevRoleSwitcher'

interface AppHeaderProps {
  onToggleSidebar: () => void
}

const AppHeader: React.FC<AppHeaderProps> = ({ onToggleSidebar }) => {
  const headerRef = useRef<HTMLDivElement>(null)
  const { t } = useTranslation()

  useEffect(() => {
    const handleScroll = () => {
      headerRef.current?.classList.toggle(
        'shadow-sm',
        document.documentElement.scrollTop > 0
      )
    }
    document.addEventListener('scroll', handleScroll)
    return () => document.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <CHeader position="sticky" className="mb-4 p-0" ref={headerRef}>
      <CContainer className="border-bottom px-4" fluid>
        <CHeaderToggler
          onClick={onToggleSidebar}
          style={{ marginInlineStart: '-14px' }}
        >
          <CIcon icon={cilMenu} size="lg" />
        </CHeaderToggler>
        <CHeaderNav className="d-none d-md-flex"></CHeaderNav>
        <CHeaderNav className="d-none d-md-flex ms-auto">
          {import.meta.env.DEV && <DevRoleSwitcher />}
        </CHeaderNav>
        <CHeaderNav className="ms-auto ms-md-0">
          {/* Separated from whatever sits to its left — in dev that is the role switcher, which
              otherwise crowds the badge. */}
          <li className="nav-item py-1">
            <div className="vr h-100 mx-2 text-body text-opacity-75"></div>
          </li>
          <AppHeaderNotifications />
          <li className="nav-item py-1">
            <div className="vr h-100 mx-2 text-body text-opacity-75"></div>
          </li>
          <ThemeToggle label={t('common:header.theme')} />
          <li className="nav-item py-1">
            <div className="vr h-100 mx-2 text-body text-opacity-75"></div>
          </li>
          <AppHeaderDropdown />
        </CHeaderNav>
      </CContainer>
      <CContainer className="px-4" fluid>
        <AppBreadcrumb />
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
